import Vue from 'vue';
import {
  install,
  Prototypes,
  Button,
  DropdownMenu,
  Pagination,
  Select,
  Search,
  // Affix,
  // Avatar,
  // BackTop,
  // Badge,
  // Breadcrumb,
  // Checkbox,
  // Circle,
  // Category,
  // CategoryPicker,
  // DatePicker,
  // DateRangePicker,
  // DateFullRangePicker,
  // DropdownCustom,
  // ImagePreview,
  // Form,
  // FormItem,
  // FormItemList,
  // Menu,
  // Modal,
  // ModalComponent,
  // Poptip,
  // Progress,
  // Radio,
  // Rate,
  // Slider,
  // Loading,
  // Steps,
  // HSwitch,
  // SwitchList,
  // Skeleton,
  // Table,
  // TableItem,
  // Tabs,
  // TagInput,
  // Tree,
  // TreePicker,
  // NumberInput,
  // Tooltip,
  // Uploader,
  // AutoComplete,
  // Row,
  // Cell,
  // HHeader,
  // HFooter,
  // Content,
  // Sider,
  // Layout,
  // Timeline,
  // TimelineItem,
  // Transfer,
  // ButtonGroup,
  // TextEllipsis,
  // Carousel,
  // Collapse,
  // CollapseItem
} from 'heyui';

Vue.use(
  install,
  {
    components: {
      Button,
      DropdownMenu,
      Pagination,
      Select,
      Search,
    },
    prototypes: Prototypes,
  },
);